import * as React from 'react';

function SvgIconImagePlaceholder(props) {
  return (
    <svg width={208} height={88} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#E8E8E8" d="M16 18h176v2H16z" />
      <rect
        x={105}
        y={29}
        width={86}
        height={20}
        rx={1}
        stroke="#D9D9D9"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        fill="#E8E8E8"
        d="M16 28h80v2H16zm0 10h80v2H16zm0 10h80v2H16zm0 10h176v2H16zm0 10h176v2H16z"
      />
    </svg>
  );
}

export default SvgIconImagePlaceholder;
